import { useContext } from "react";
import { AppContext, IAppContext } from "@ottomotors/ottomotors.com/context";

export const useApp = (): IAppContext => useContext(AppContext);

export default useApp;
